import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/reset-password')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/reinitialiser-mot-de-passe' })
  },
  validateSearch: z.object({
    token: z.string(),
  }),
})
